/**
 * Created by jacmai on 3/23/2017.
 */

define(["backbone", "underscore", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  _,
  Properties,
  Messenger,
) {
  var ApiRequestValidationModel = {};

  ApiRequestValidationModel.testRequest = Backbone.Model.extend({
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/actiongroup/apirequest/validate";
    },
    testApiRequest: function (apiRequest, testVariableCol) {
      //keep a reference to the api request
      this.apiRequest = apiRequest;
      this.set("apiId", apiRequest.get("apiId"));
      this.set("path", apiRequest.get("path"));
      this.set("httpMethod", apiRequest.get("httpMethod"));
      this.set("requestBody", apiRequest.get("requestBody"));
      var testVariableMap = {};
      testVariableCol.each(function (testVariable) {
        testVariableMap[testVariable.id.toString()] = testVariable.get("testValue");
      });
      this.set("testVariables", testVariableMap);
      this.save(null, {});
    },
    parse: function (rawAttr) {
      //parse the JSON response to models and collections
      rawAttr.response = new ApiRequestValidationModel.responseJsonValue(
        { value: rawAttr.response },
        { parse: true },
      );
      if (rawAttr.successful) {
        var responseVariables = this.apiRequest.getResponseVariables();
        //determine the path for each element in the JSON object
        // and apply any existing response variable mappings.  All response variables
        //that can be matched in the response are returned.
        var matchedVariables = rawAttr.response.setPath(responseVariables);
        //Remove any variables that are not matched in the response
        var missingVariables = [];
        responseVariables.forEach(function (variable) {
          if (matchedVariables.indexOf(variable) === -1) {
            missingVariables.push(variable);
          }
        });
        missingVariables.forEach(function (variable) {
          this.apiRequest.removeResponseVariable(variable.conversationVariableId);
        }, this);
      }
      return rawAttr;
    },
  });

  //Model representing a JSON object
  ApiRequestValidationModel.responseJsonValue = Backbone.Model.extend({
    defaults: {
      conversationVariableId: 0, //mapped variable
      showEditMenu: false,
    },
    setPath: function (responseVariables, currentPath) {
      this.path = currentPath;
      if (this.get("collection")) {
        return this.get("collection").setPath(responseVariables, currentPath);
      } else {
        //It's a value that can be mapped to a variable, so check if there is a response variable assigned already.
        //Also attach the list of conversation variables so we can display the variable's name and the selection menu
        //Do not include reserved variables because those should only be assigned a value by the engine itself
        this.set("variables", Messenger.reqres.request("action:variables"));
        if (responseVariables) {
          var matchedVariable = _.findWhere(responseVariables, { element: this.path });
          if (matchedVariable) {
            this.set("conversationVariableId", matchedVariable.conversationVariableId);
            return [matchedVariable];
          }
          return [];
        }
      }
    },
    parse: function (rawValue) {
      var parsedObj = {};
      //determine what kind of value we are dealing with.  Order matters here because JS arrays are objects too.
      if (_.isArray(rawValue.value)) {
        parsedObj.type = "array";
        parsedObj.collection = new ApiRequestValidationModel.responseJsonArray(rawValue.value, {
          parse: true,
        });
      } else if (_.isObject(rawValue.value)) {
        parsedObj.type = "object";
        parsedObj.collection = new ApiRequestValidationModel.responseJsonObject(rawValue.value, {
          parse: true,
        });
      } else if (_.isNumber(rawValue.value)) {
        parsedObj.type = "number";
        parsedObj.value = rawValue.value;
      } else if (_.isString(rawValue.value)) {
        parsedObj.type = "string";
        parsedObj.value = rawValue.value;
      } else if (_.isBoolean(rawValue.value)) {
        parsedObj.type = "boolean";
        parsedObj.value = rawValue.value;
      } else if (_.isNull(rawValue.value)) {
        parsedObj.type = "null";
        parsedObj.value = rawValue.value;
      }
      return parsedObj;
    },
  });

  ApiRequestValidationModel.responseJsonNameValuePair = Backbone.Model.extend({
    setPath: function (responseVariables, currentPath) {
      // Must escape special characters that might be in the value so it does not mess up matching the path later
      this.path = currentPath + this.get("value").replace(/([.[\]])/g, "\\$1");
      return this.get("collection").at(0).setPath(responseVariables, this.path);
    },
    parse: function (nameValuePair) {
      //parse a tuple ["test", "result"] into an object {"name": "test", "value": responseJsonValueModel}
      return {
        type: "tuple",
        value: nameValuePair[0],
        collection: new Backbone.Collection([
          //use a collection to keep consistent with the JsonValue object
          new ApiRequestValidationModel.responseJsonValue(
            { value: nameValuePair[1] },
            { parse: true },
          ), //wrap value in object
        ]),
      };
    },
  });

  ApiRequestValidationModel.responseJsonArray = Backbone.Collection.extend({
    model: ApiRequestValidationModel.responseJsonValue,
    setPath: function (responseVariables, currentPath) {
      if (!currentPath) {
        //add pseudo root if array is the top level element
        this.path = "/root/";
      } else {
        this.path = currentPath;
      }
      var matchedVariables = [];
      for (var i = 0; i < this.length; i++) {
        Array.prototype.push.apply(
          matchedVariables,
          this.at(i).setPath(responseVariables, this.path + "[" + i + "]"),
        );
      }
      return matchedVariables;
    },
    parse: function (jsonArray) {
      var parsedArray = [];
      jsonArray.forEach(function (arrElement) {
        parsedArray.push({ value: arrElement }); //wrap array element in an object
      });
      return parsedArray;
    },
  });

  ApiRequestValidationModel.responseJsonObject = Backbone.Collection.extend({
    model: ApiRequestValidationModel.responseJsonNameValuePair,
    setPath: function (responseVariables, currentPath) {
      if (currentPath) {
        this.path = currentPath + ".";
      } else {
        this.path = "";
      }
      var matchedVariables = [];
      this.forEach(function (nameValuePair) {
        Array.prototype.push.apply(
          matchedVariables,
          nameValuePair.setPath(responseVariables, this.path),
        );
      }, this);
      return matchedVariables;
    },
    parse: function (jsonObject) {
      //parse the json object into an array of name value pairs
      var parsedPairs = _.pairs(jsonObject);
      return parsedPairs;
    },
  });

  ApiRequestValidationModel.testVariable = Backbone.Model.extend({
    defaults: {
      testValue: "",
    },
  });

  ApiRequestValidationModel.testVariables = Backbone.Collection.extend({
    model: ApiRequestValidationModel.testVariable,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
  });

  /**
   * Create a collection from a variable Id array and a collection of all variables in the KB.
   * Each model in the collection contains the variable Id, variable name, and the test value
   * for that variable.
   */
  Messenger.reqres.setHandler("api:test:variables", function (variableIdArr, allVariablesCol) {
    var collection = new ApiRequestValidationModel.testVariables();
    variableIdArr.forEach(function (variableId) {
      var variableObj = allVariablesCol.get(variableId);
      collection.add({ id: variableId, name: variableObj.get("name") });
    });
    return collection;
  });

  return ApiRequestValidationModel;
});
